import { Injectable } from '@angular/core';

import { BetState } from '@bpos/v1/my-bets';
import { PicksView } from '@cds/betting-offer/domain-specific';
import { BettingOfferApi } from '@frontend/sports/betting-offer/feature/offer-service';
import { flatten } from 'lodash-es';

import { MyBetsBetSlip } from '../../../my-bets-base/models/my-bets-viewmodels';
import { BetslipPicksRequestBuilderService } from '../../services/betslip-pick-request-builder.service';

@Injectable()
export class ReBetLoaderService {
    constructor(
        private apiService: BettingOfferApi,
        private betslipPicksRequestBuilder: BetslipPicksRequestBuilderService,
    ) {}

    async loadPicks(betslips: MyBetsBetSlip[]): Promise<PicksView | undefined> {
        let bets = flatten(betslips.map((b) => b.bets));
        bets = bets.filter((b) => [BetState.Open, BetState.Placed].indexOf(b.state) > -1);

        if (!bets.length) {
            return;
        }

        const request = this.betslipPicksRequestBuilder.buildRequestFromBets(bets);

        return this.apiService.getReBetPicksView(request).toPromise();
    }
}
